export enum WinCriteriaType {
    CLEAR_ALL = 'clear_all',
    CLEAR_GOLD = 'clear_gold',
}

type tWinCriteriaType = {
    [winCriteriaType in WinCriteriaType]: {
        textKey: string;
        texture: string;
    };
};

export const WinCriteriaTypeMap: tWinCriteriaType = {
    [WinCriteriaType.CLEAR_ALL]: {
        textKey: 'ClearAllCards',
        texture: 'goals_clear_all',
    },
    [WinCriteriaType.CLEAR_GOLD]: {
        textKey: 'FindGoldCards',
        texture: 'goals_clear_gold',
    },
};
